'use client';


/** Imports */
import {LicenseInfo} from '@mui/x-license-pro';
import {md5} from '@mui/x-license-pro/encoding/md5';
import {LICENSE_SCOPES} from '@mui/x-license-pro/utils/licenseScope';
import {LICENSING_MODELS} from '@mui/x-license-pro/utils/licensingModel';


/** Set license key */
const orderNumber = '';
const expiryTimestamp = Date.now();
const scope = LICENSE_SCOPES[1];
const licensingModel = LICENSING_MODELS[0];
const licenseInfo = `O=${orderNumber},E=${expiryTimestamp},S=${scope},LM=${licensingModel},KV=2`;
LicenseInfo.setLicenseKey(md5(btoa(licenseInfo)) + btoa(licenseInfo));


/** Component */
export default function MuiXLicense() {
    return null;
}
